// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_7a3fb80146--carousel--FCofi","content":"_7a3fb80146--content--dM_v3","layout":"_7a3fb80146--layout--nBxkK"};